import { render, staticRenderFns } from "./DpiEffect.vue?vue&type=template&id=cfaf976e&scoped=true"
import script from "./DpiEffect.vue?vue&type=script&lang=js"
export * from "./DpiEffect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfaf976e",
  null
  
)

export default component.exports